import { CheckDto } from '../check-dto';
import { CustomerVenue } from '../Customer/CustomerVenue.entity';
import { CustomerSubscriptionItem } from '../CustomerSubscription.item';
import { CustomerTokenItem } from '../CustomerToken.item';
import { MyFocusLoyaltyMemberDTO } from './MyFocus-Loyalty.dto';

export class CustomerSearchResult {
	totalRecords: number;
	take: number;
	skip: number;
	records: CustomerDto[];

	public constructor(init?: Partial<CustomerSearchResult>) {
		Object.assign(this, init);
	}
}
export class CustomerDto {
	key: string;
	firstName: string;
	lastName: string;
	displayName?: string;
	email: string;
	phone: string[];
	addresses: CustomerAddressDto[] = [];
	visitCount: number;
	totalRevenue: number;
	firstVisitDate: Date;
	lastVisitDate: Date;
	visits: CustomerVisitDto[];
	onlineOrders: CustomerVisitDto[];
	pictureKey: string;
	track: boolean;
	tags: string[];
	notes: string[];
	optOut: Date;
	loyaltyId: string;

	loyaltyMember: boolean;
	averageSpend: number;

	loyalty: MyFocusLoyaltyMemberDTO;

	tokens: CustomerTokenItem[];

	subscriptions: CustomerSubscriptionItem[];

	public constructor(init?: Partial<CustomerDto>) {
		Object.assign(this, init);
	}

	toCustomerVenue(venueKey: number) {
		return new CustomerVenue({
			venueKey: venueKey,
			customerKey: this.key,
			track: this.track,
			tags: this.tags,
		});
	}
}

export class CustomerAddressDto {
	street1: string;
	street2: string;
	city: string;
	state: string;
	postalCode: string;

	displayName: string;

	firstUseVenueKey: number;
	firstUseDateTime: string;

	public constructor(init?: Partial<CustomerAddressDto>) {
		Object.assign(this, init);
	}
}

export class CustomerVisitDto {
	visitDate: Date;
	revenue: number;
	checkKey: string;
	check: CheckDto;
	source: number;

	public constructor(init?: Partial<CustomerVisitDto>) {
		Object.assign(this, init);
	}
}
